var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHour24Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5127_3197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 8.66659C9.10483 8.66659 10.0002 9.56192 10.0002 10.6666C10.0002 11.2333 9.76483 11.7439 9.38683 12.1079L8.1135 13.3333H10.0002V14.6666H6.00016V13.5173L8.46216 11.1473C8.58883 11.0253 8.66683 10.8553 8.66683 10.6666C8.66683 10.2986 8.36816 9.99992 8.00016 9.99992C7.63216 9.99992 7.3335 10.2986 7.3335 10.6666H6.00016C6.00016 9.56192 6.8955 8.66659 8.00016 8.66659ZM12.0002 8.66659V11.3333H13.3335V8.66659H14.6668V14.6666H13.3335V12.6666H10.6668V8.66659H12.0002ZM2.00016 7.99992C2.36835 7.99992 2.66244 8.29962 2.70787 8.665C2.86831 9.95534 3.48946 11.1025 4.40159 11.9367C4.56452 12.0858 4.66683 12.2924 4.66683 12.5132V12.5132C4.66683 13.0735 4.06467 13.4105 3.64085 13.0439C2.38517 11.9578 1.53928 10.4108 1.36631 8.6656C1.32999 8.2992 1.63197 7.99992 2.00016 7.99992V7.99992ZM8.00016 1.33325C11.2006 1.33325 13.8746 3.5889 14.5186 6.59698C14.6022 6.98727 14.2874 7.33325 13.8882 7.33325V7.33325C13.5477 7.33325 13.2651 7.07793 13.1854 6.74688C12.6218 4.40611 10.5143 2.66659 8.00016 2.66659C6.16683 2.66659 4.5495 3.59125 3.59016 4.99992H4.66683C5.03502 4.99992 5.3335 5.2984 5.3335 5.66659V5.66659C5.3335 6.03478 5.03502 6.33325 4.66683 6.33325H1.60747C1.45616 6.33325 1.3335 6.21059 1.3335 6.05928V2.99992C1.3335 2.63173 1.63197 2.33325 2.00016 2.33325V2.33325C2.36835 2.33325 2.66683 2.63173 2.66683 2.99992V3.99992C3.88283 2.37992 5.8195 1.33325 8.00016 1.33325Z",
    fill: "#DC2626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5127_3197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHour24Icon);
export default __webpack_public_path__ + "static/media/hour24Icon.db42fd11.svg";
export { ForwardRef as ReactComponent };